<template>
  <transition
    @enter="enter"
    @leave="leave"
    appear
  >
    <aside
      :key="voice.id"
      class="prev"
      v-if="voice.id !== undefined"
      style="opacity: 0;"
      :style="{ pointerEvents: $store.state.isTrans ? 'none' : 'auto' }"
    >
      <div
        class="breadcrumbs__wrapper"
        :data-project="voice.project"
      >
        <Breadcrumbs
          :voice="voice"
          :hover="hover"
          direction="prev"
          trans="siblings-prev"
        />

        <div
          class="prev__wrapper"
          :data-project="voice.project"
        >
          <a
            :href="voice.url"
            :data-nav="voice.id"
            class="prev__link"
            :aria-label="voice.text"
            @click.prevent="$goTo(voice.url, 'siblings-prev');"
            @mouseenter="hover = true;"
            @mouseleave="hover = false;"
          >
            <Title
              :text="voice.text"
              :size="$route.name === 'project' ? 'normal' : $route.name === 'person' ? 'team' : 'big'"
              data-anim="title-next"
            />
          </a>
        </div>
      </div>
    </aside>
  </transition>
</template>

<script>
import upperCase from 'lodash/upperCase';
import { TweenMax, Expo } from 'gsap/TweenMax';
import { mapGetters } from 'vuex';

import { initial, animations } from '@/assets/animations';
import hades from '@/scripts/hades';
import aion from '@/scripts/aion';
import translate from '@/assets/i18n';

import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import Title from '@/components/text/Title.vue';

export default {
  name: 'prev',

  components: {
    Breadcrumbs,
    Title,
  },

  data() {
    return {
      voice: {},
      voiceClone: {},
      signal: true,
      hover: false,
    };
  },

  computed: {
    ...mapGetters({
      routeName: 'getRouteName',
      menu: 'getMenu',
      init: 'getInit',
    }),
  },

  watch: {
    init(n) {
      this.change(this.routeName);
    },

    routeName(n) {
      if (n && this.init) {
        setTimeout(() => {
          this.change(n);
        }, 500);
      }
    },

    menu(n) {
      if (!n) this.signal = true;
    },
  },

  mounted() {
    // this.$eventHub.$on('leave', this.checkClone);
    // aion.add(this.checkPrev, 'checkPrev', true);
  },

  beforeDestroy() {
    // this.$eventHub.$off('leave', this.checkClone);
    // aion.remove('checkPrev');
  },

  methods: {
    enter(el, done) {
      this.$nextTick(() => {
        if (el.style !== undefined) {
          el.style.opacity = '1';

          Array.from(el.querySelectorAll('[data-anim]:not([data-animated])')).forEach((element) => {
            initial.get(element.dataset.anim)(element);
          });
        }
      });
      done();
    },

    leave(el, done) {
      TweenMax.to(el, 0.5, {
        autoAlpha: 0,
        x: -20,
        ease: Expo.easeOut,
        onComplete: done,
      });
    },

    change(route) {
      if (route === 'home' || this.$route.name === 'error404') {
        this.voice = {};
      } else {
        let order = 0;

        const active = route;
        const { lang } = this.$store.state;
        const projects = this.$route.name !== 'project' ? this.$route.name !== 'person' ? '' : '/team' : lang === 'it' ? '/investimenti' : '/investments';
        const pathLang = lang === 'it' ? 'path' : 'pathEn';
        const data = this.$route.name === 'project' ? this.$store.state.firebase.investimenti.childrens : this.$route.name === 'person' ? this.$store.state.firebase.team.childrens : this.$store.state.firebase;

        Object.keys(data).forEach((key) => {
          if (key === active) {
            if (data[key].order === 1 && this.$route.name !== 'project' && this.$route.name !== 'person') {
              order = Object.keys(data).length;
            } else if (data[key].order === 0 && (this.$route.name === 'project' || this.$route.name === 'person')) {
              order = Object.keys(data).length;
            } else {
              order = data[key].order;
            }
          }
        });

        Object.keys(data).forEach((key) => {
          if (data[key].order === order - 1) {
            this.voice = {
              id: key,
              url: `/${lang}${projects}${data[key][pathLang]}`,
              text: this.$route.name !== 'project' && this.$route.name !== 'person' ? translate(upperCase(key), lang) : data[key].name,
              label: 'Prev',
              project: this.$route.name === 'project' || this.$route.name === 'person',
            };

            this.$store.commit('SET_PREV', this.voice);
          }
        });

        if (this.voice.id !== undefined) {
          this.$nextTick(() => {
            this.voiceClone = {
              dataNav: this.voice.id,
              el: document.querySelector('.prev__link'),
            };

            // this.clone();
          });
        }
      }
    },

    clone() {
      this.$eventHub.$emit('addTitleCloning', this.voiceClone);
    },

    checkClone() {
      const clones = Array.from(document.querySelectorAll('.app__clone > *'));
      const filter = clones.filter(el => el.dataset.nav === this.voice.id);
      if (filter.length === 0) {
        this.clone();
      }
    },

    checkPrev() {
      if (this.$store.state.menu) return;

      if (hades.ref.amount.y > 50 && hades.ref.amount.y < window.innerHeight) {
        TweenMax.to(this.$el, 0.25, {
          autoAlpha: 0,
          ease: Expo.easeOut,
        });
      } else if (hades.ref.amount.y <= 50) {
        TweenMax.to(this.$el, 0.25, {
          autoAlpha: 1,
          ease: Expo.easeOut,
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
aside {
  @include mq($until: ipadP) {
    display: none;
  }

  grid-area: a;

  .breadcrumbs {
    &__wrapper {
      position: relative;
      display: inline-block;
    }
    &__line {
      position: relative;
      margin-left: rem(10px);
      width: rem(50px);
      height: 1px;

      background-color: $color-dark-light;
    }
  }

  .prev {
    &__wrapper {
      position: relative;

      margin-top: rem(89px);

      &[data-project] {
        margin-top: rem(70px);
      }
    }
    &__link {
      position: absolute;
      right: 0;
      h2 {
        color: rgba($color: $color-bg, $alpha: 0.2);
        color: $color-bg;
        white-space: nowrap;
      }
    }
  }
}
</style>
